import { render, staticRenderFns } from "./systemParticulars.vue?vue&type=template&id=381e5421&scoped=true&"
import script from "./systemParticulars.vue?vue&type=script&lang=js&"
export * from "./systemParticulars.vue?vue&type=script&lang=js&"
import style0 from "./systemParticulars.vue?vue&type=style&index=0&id=381e5421&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e5421",
  null
  
)

export default component.exports